<div
  class="mt-5 bg-white col-span-12 p-1 border rounded-3xl md:rounded-full w-full  md:flex-row justify-end gap-3 md:gap-0">
  <div class="flex flex-wrap rounded-full bg-gray-200/30">
    @for (menu of tabItems; track $index) {
      @if (menu?.slug === activeSlug) {
        <button
          class="px-3 py-2 rounded-full bg-primary-50 text-primary font-bold grow md:grow-0 delay-75 duration-200 ease-out hover:ease-in transition-all">
          {{ menu.title }} <span
          class="p-1 px-2 ml-1 bg-white rounded-full border-primary border-2">{{ menu?.count }}</span>
        </button>
      } @else {
        <button (click)="activeSlug = menu.slug; activeIndex=$index"
                [ngClass]="(activeIndex +1 == $index? '-ml-3 pr-3 pl-4 hover:rounded-r-full' :activeIndex -1 == $index?'-mr-3 pr-4 pl-3 hover:rounded-l-full' : 'px-3 hover:rounded-full')"
                class="py-2 grow md:grow-0 ease-out hover:ease-in transition-all hover:bg-primary-50 hover:text-primary ">
          {{ menu.title }} <span
          class="p-1 px-2 ml-1 bg-white rounded-full border-gray-300 border-2">{{ menu?.count }}</span>
        </button>
      }
    }
  </div>
</div>
